/**
 * Event History page translations
 * 
 * This file contains translations for the Event History page.
 */

import { EventHistoryTranslationType } from './types';

// English translations
export const enEventHistory: EventHistoryTranslationType = {
  eventHistory: {
    title: "Event History",
    subtitle: "events saved",
    clearAll: "Clear All",
    confirmClearAll: "Are you sure you want to clear all event history?",
    infoBanner: {
      title: "Event History",
      messageLoggedIn: "Events you visit are automatically saved here",
      messageLoggedOut: "Events you visit are automatically saved here. Sign in to sync across devices",
      saveEventInfo: ""
    },
    search: "Search events...",
    emptyState: {
      noSavedEvents: "No saved events",
      noMatchingEvents: "No events match your search",
      startExploring: "Start exploring events and save them to your history",
      adjustSearch: "Try adjusting your search terms"
    },
    savedTime: "Saved {{time}}",
    view: "View"
  }
};

// Vietnamese translations
export const viEventHistory: EventHistoryTranslationType = {
  eventHistory: {
    title: "Lịch Sử Sự Kiện",
    subtitle: "sự kiện đã lưu",
    clearAll: "Xóa Tất Cả",
    confirmClearAll: "Bạn có chắc chắn muốn xóa tất cả lịch sử sự kiện không?",
    infoBanner: {
      title: "Lịch Sử Sự Kiện",
      messageLoggedIn: "Các sự kiện bạn truy cập sẽ được tự động lưu tại đây",
      messageLoggedOut: "Các sự kiện bạn truy cập sẽ được tự động lưu tại đây. Đăng nhập để đồng bộ giữa các thiết bị",
      saveEventInfo: ""
    },
    search: "Tìm kiếm sự kiện...",
    emptyState: {
      noSavedEvents: "Không có sự kiện đã lưu",
      noMatchingEvents: "Không có sự kiện nào phù hợp với tìm kiếm của bạn",
      startExploring: "Bắt đầu khám phá sự kiện và lưu chúng vào lịch sử của bạn",
      adjustSearch: "Hãy thử điều chỉnh các từ khóa tìm kiếm"
    },
    savedTime: "Đã lưu {{time}}",
    view: "Xem"
  }
};